import { Injectable, inject } from '@angular/core';
import { TabsStateService } from '../../shared/services/tabs-state.service';
import { ClinicDetailStateService } from '../services/clinic-and-owner-clinic/clinics/clinic-detail/clinic-detail-state.service';
import { HotelDetailStateService } from '../services/hotels/hotel-detail/hotel-detail-state.service';
import { StoreDetailStateService } from '../services/stores/store-detail/store-detail-state.service';
import { OtherDetailStateService } from '../services/others/other-detail/other-detail-state.service';
import { PetTransporterDetailStateService } from '../services/pet-transporters/pet-transporter-detail/pet-transporter-detail-state.service';
import { GroomerDetailStateService } from '../services/groomers/groomer-detail/groomer-detail-state.service';
import { WalkerDetailStateService } from '../services/walkers/walker-detail/walker-detail-state.service';
import { TrainerDetailStateService } from '../services/trainers/trainer-detail/trainer-detail-state.service';
import { PromotionDetailStateService } from '../services/promotions/promotion-detail/promotion-detail-state.service';
import { PetInsuranceDetailStateService } from '../services/pet-insurances/pet-insurance-detail/pet-insurance-detail-state.service';

@Injectable({ providedIn: 'root' })
export class AdminOrganizationDetailNavigationService {
  private tabsStateService = inject(TabsStateService);
  private clinicDetailState = inject(ClinicDetailStateService);
  private hotelDetailState = inject(HotelDetailStateService);
  private storeDetailState = inject(StoreDetailStateService);
  private otherDetailState = inject(OtherDetailStateService);
  private petTransporterDetailState = inject(PetTransporterDetailStateService);
  private groomerDetailState = inject(GroomerDetailStateService);
  private walkerDetailState = inject(WalkerDetailStateService);
  private trainerDetailState = inject(TrainerDetailStateService);
  private promotionDetailState = inject(PromotionDetailStateService);
  private petInsuranceDetailState = inject(PetInsuranceDetailStateService);

  open(entityType: string | undefined, entityUid: string | undefined): boolean {
    const uid = entityUid?.trim();
    if (!uid) {
      return false;
    }

    const normalizedType = (entityType ?? '').trim();
    switch (normalizedType) {
      case 'Clinic':
        this.clinicDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Clinics');
        return true;
      case 'Hotel':
        this.hotelDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Hotels');
        return true;
      case 'Store':
        this.storeDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Stores');
        return true;
      case 'Other':
        this.otherDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Others');
        return true;
      case 'Transport':
        this.petTransporterDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Pet Transporters');
        return true;
      case 'Groomer':
        this.groomerDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Groomers');
        return true;
      case 'Walker':
        this.walkerDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Walkers');
        return true;
      case 'Trainer':
        this.trainerDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Trainers');
        return true;
      case 'Promotion':
        this.promotionDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Promotions');
        return true;
      case 'PetInsurance':
        this.petInsuranceDetailState.open(uid);
        this.tabsStateService.createOpenTabs('Pet Insurances');
        return true;
      case 'AnimalClub':
        this.tabsStateService.createOpenTabs('Clubs');
        return true;
      default:
        return false;
    }
  }
}
